import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=6b4b580e&scoped=true"
import script from "./Vendors.vue?vue&type=script&lang=js"
export * from "./Vendors.vue?vue&type=script&lang=js"
import style0 from "./Vendors.vue?vue&type=style&index=0&id=6b4b580e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b580e",
  null
  
)

export default component.exports